import { motion } from 'framer-motion';

function Terms() {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="container mx-auto px-4 py-8 max-w-4xl"
    >
      <h1 className="text-3xl font-bold mb-8 bg-gradient-to-r from-primary-500 to-secondary-500 bg-clip-text text-transparent">
        Terms of Service
      </h1>

      <div className="prose dark:prose-invert max-w-none">
        <p className="text-gray-600 dark:text-gray-300 mb-6">
          Last updated: {new Date().toLocaleDateString()}
        </p>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">1. Acceptance of Terms</h2>
          <p>
            By accessing and using this website, you accept and agree to be bound by the terms and 
            provision of this agreement.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">2. User Responsibilities</h2>
          <ul className="list-disc pl-6 mb-4">
            <li>You must be at least 13 years old to use this service</li>
            <li>You are responsible for maintaining the security of your account</li>
            <li>You agree not to use the service for any illegal purposes</li>
            <li>You must not abuse, harass, or threaten other users</li>
          </ul>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">3. Content Guidelines</h2>
          <p>When posting content on our platform, you agree to follow these guidelines:</p>
          <ul className="list-disc pl-6 mb-4">
            <li>Content must be original or properly attributed</li>
            <li>No hate speech or discriminatory content</li>
            <li>No spam or misleading information</li>
            <li>No adult or explicit content</li>
          </ul>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">4. Intellectual Property</h2>
          <p>
            All content published on this website, including text, graphics, logos, and images, 
            is the property of the website owner or content creators and is protected by copyright laws.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">5. Termination</h2>
          <p>
            We reserve the right to terminate or suspend your account and access to our services 
            at our sole discretion, without notice, for conduct that we believe violates these 
            Terms of Service or is harmful to other users, us, or third parties, or for any other reason.
          </p>
        </section>
      </div>
    </motion.div>
  );
}

export default Terms; 